/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

const swiperLesson = new Swiper('.j-lesson-swiper', {
  navigation: {
    nextEl: '.j-lesson-swiper-button-next',
    prevEl: '.j-lesson-swiper-button-prev',
  },
  spaceBetween: 60,
  observer: true,
  observeSlideChildren: true,
  on: {
    slideChange: function () {
      lessonBtnRemoveStyles();
      navBtns[this.activeIndex].element.classList.add('active');
    },
    init: function () {
      setEqualHeight();
    },
    resize: function(){
      setEqualHeight();
    }
  },
});

const swiperExperience = new Swiper('.j-l-experience-swiper', {
  spaceBetween: 40,
  pagination: {
    el: '.j-experience-swiper-pagination',
  },
  navigation: {
    nextEl: '.j-experience-swiper-button-next',
    prevEl: '.j-experience-swiper-button-prev',
  },
});

const basicLesson = document.querySelector('#basicLesson');
const advancedLesson = document.querySelector('#advancedLesson');
const groupProject = document.querySelector('#groupProject');
const lessonBtns = document.querySelectorAll('.c-lesson-btn');

function lessonBtnRemoveStyles() {
  lessonBtns.forEach((lessonBtn) => {
    lessonBtn.classList.remove('active');
  });
}

const navBtns = [
  { element: basicLesson, slide: 0 },
  { element: advancedLesson, slide: 1 },
  { element: groupProject, slide: 2 }
];

navBtns.forEach((navBtn) => {
  navBtn.element.addEventListener('click', (e) => {
    swiperLesson.slideTo(navBtn.slide);
    lessonBtnRemoveStyles();
    navBtn.element.classList.add('active');
  });
});

// mobile accordion controller
const navCollapseDiv = document.querySelector('#navCollapse');
const accordionLinks = document.querySelectorAll('.c-accordion-link');

accordionLinks.forEach((accordionLink) => {
  accordionLink.addEventListener('click', (e) => {
    navCollapseDiv.classList.remove('show');
  });
});

document.addEventListener('click', closeAccordion);

function closeAccordion(event) {
  navCollapseDiv.classList.remove('show');
}

// animation lottie
const animationMedalData = {
  container: document.getElementById('j-medal-animation'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: './assets/images/front/home/medal.json',
  rendererSettings: {
    className: 'c-animation',
  },
};
const animationMedal = lottie.loadAnimation(animationMedalData);

const animationRunData = {
  container: document.getElementById('j-run-animation'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: './assets/images/front/home/run.json',
  rendererSettings: {
    className: 'c-animation',
  }
};
const animationRun = lottie.loadAnimation(animationRunData);

const animationMobileRunData = {
  container: document.getElementById('j-run-mobile-animation'),
  renderer: 'svg',
  loop: true,
  autoplay: true,
  path: './assets/images/front/home/run.json',
};
const animationMobileRun = lottie.loadAnimation(animationMobileRunData);

// swiper height
function setEqualHeight() {
  const slides = document.querySelectorAll(".j-lesson-swiper .swiper-slide");
  const cards = document.querySelectorAll(".c-lesson-card");
  let maxHeight = 0;

  cards.forEach(card => {
    card.style.height = 'auto';
  });
  slides.forEach(slide => {
    slide.style.height = 'auto';
  });

  cards.forEach(card => {
    maxHeight = Math.max(maxHeight, card.offsetHeight);
  });

  cards.forEach(card => {
    card.style.height = `${maxHeight}px`;
  });
  slides.forEach(slide => {
    slide.style.height = `${maxHeight}px`;
  });
}

let resizeTimeout;
window.addEventListener('resize', () => {
  if (resizeTimeout) {
    cancelAnimationFrame(resizeTimeout);
  }
  resizeTimeout = requestAnimationFrame(() => {
    setEqualHeight();
  });
});
